<template>
    <ai-popup
        :title="'Блокировки пользователя: ' + state.userRequestBody.fio"
        :bottom-buttons-enabled="true"
        width="60%"
        height="75%"
        v-model:visible="state.userLocksPopupVisible"
        :first-button-disabled="isDisableUiElement"
        @submit-click="saveClick"
        @close-popup="closePopup"
    >
        <users-blockages ref="usersBlockagesRef" />
    </ai-popup>
</template>

<script setup>
import { ref } from 'vue';
import AiPopup from '@/components/ai-popup/ai-popup.vue';
import UsersBlockages from '@/views/administration/users/users-blockages.vue';
import { dxUiNotify } from '@/utils/dx-helper';
import { lockUser } from '@/service/admin-service.js';
import environmentStore from '@/store/enviroment-data.js';
import usersLocalStore from '@/views/administration/users/store.js';

const { disableUiElement } = environmentStore;
const { state, UI_ELEMENTS_IDS } = usersLocalStore;

const usersBlockagesRef = ref();
const emit = defineEmits(['refreshUserGrid']);
const refreshUserGrid = ref(false);
const isDisableUiElement = disableUiElement(UI_ELEMENTS_IDS.BLOCKAGES);

const closePopup = () => {
    if (refreshUserGrid.value) emit('refreshUserGrid');
    state.userLocksPopupVisible = false;
};

const saveClick = async () => {
    const isDateBegLessDateEnd = usersBlockagesRef.value.checkDateBegLessDateEnd();
    if (!isDateBegLessDateEnd) {
        failedSave('Дата начала блокировки должна быть позже даты окончания', false);
        return;
    }

    const locks = usersBlockagesRef.value.prepareLocksForSave();

    const response = await lockUser(state.userRequestBody.deleted_locks, locks);
    if (response.success) {
        refreshUserGrid.value = true;
        state.userRequestBody.locks = [];
        state.userRequestBody.deleted_locks = [];
        closePopup();
        dxUiNotify('Данные сохранены', 'success');
    } else {
        const errorMessage = `Ошибка при сохранении данных: ${response.errors[0].message}`;
        failedSave(errorMessage, true);
    }
};

const failedSave = (errorMessage, checkRequiredFields) => {
    if (checkRequiredFields) usersBlockagesRef.value.checkRequiredFieldsValidation();
    dxUiNotify(`${errorMessage}`, 'error');
};
</script>
